/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateStockup201ResponseAllOfData } from './CreateStockup201ResponseAllOfData';
import {
    CreateStockup201ResponseAllOfDataFromJSON,
    CreateStockup201ResponseAllOfDataFromJSONTyped,
    CreateStockup201ResponseAllOfDataToJSON,
} from './CreateStockup201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateStockup201ResponseAllOf
 */
export interface CreateStockup201ResponseAllOf {
    /**
     * 
     * @type {CreateStockup201ResponseAllOfData}
     * @memberof CreateStockup201ResponseAllOf
     */
    data: CreateStockup201ResponseAllOfData;
}

/**
 * Check if a given object implements the CreateStockup201ResponseAllOf interface.
 */
export function instanceOfCreateStockup201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateStockup201ResponseAllOfFromJSON(json: any): CreateStockup201ResponseAllOf {
    return CreateStockup201ResponseAllOfFromJSONTyped(json, false);
}

export function CreateStockup201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStockup201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateStockup201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function CreateStockup201ResponseAllOfToJSON(value?: CreateStockup201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateStockup201ResponseAllOfDataToJSON(value.data),
    };
}

